export default {"src":"/_next/static/media/access-gold.0df7e8f0.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};